import type { DisplayMode } from './ModelViewer';

export const DEFAULT_DISPLAY_MODE: DisplayMode = 'solid-edges';
